import {Store} from "vuex";
import StoreItemDTO from "@/models/StoreItemDTO";
import {api} from "@/service/APIClient";
import PurchaseCreateRequestDTO from "@/models/request/PurchaseCreateRequestDTO";
import {AppEvents} from "@/models/enum/AppEvents";
import {PurchaseStatus} from "@/models/enum/PurchaseStatus";
import {loadXsollaWidgetScript} from "@/composables/useXsollaWidget";

const POLL_INTERVAL_MS = 3000;
const MAX_POLL_ATTEMPTS = 300;

export async function openXsollaCheckout(item: StoreItemDTO, store: Store<any>): Promise<void> {
    const result = await api.call.purchases.create({
        itemId: item.id,
        provider: "XSOLLA"
    } as PurchaseCreateRequestDTO)

    const token = result.payment?.token
    if (!token) {
        return
    }

    await loadXsollaWidgetScript()

    let resolved = false
    let pollInterval: number|any = null
    let pollAttempts = 0

    const stopPolling = () => {
        if (pollInterval) {
            clearInterval(pollInterval)
            pollInterval = null
        }
    }

    const complete = (status: PurchaseStatus) => {
        resolved = true
        stopPolling()
        XPayStationWidget.close()
        store.dispatch('emit', {
            event: status === PurchaseStatus.COMPLETED ? AppEvents.PURCHASE_COMPLETED : AppEvents.PURCHASE_CANCELED,
            data: {purchaseId: result.id, item}
        })
    }

    const checkStatus = async () => {
        if (resolved) {
            return
        }

        pollAttempts++
        if (pollAttempts > MAX_POLL_ATTEMPTS) {
            stopPolling()
            api.call.purchases.cancel(result.id).catch(() => {})
            return
        }

        const purchase = await api.call.purchases.get(result.id)
        if (purchase.status === PurchaseStatus.COMPLETED || purchase.status === PurchaseStatus.CANCELLED) {
            complete(purchase.status)
        }
    }

    XPayStationWidget.init({
        access_token: token,
        sandbox: result.payment?.sandbox ?? false,
    })

    XPayStationWidget.on(XPayStationWidget.eventTypes.CLOSE, checkStatus)
    XPayStationWidget.on(XPayStationWidget.eventTypes.STATUS, checkStatus)

    XPayStationWidget.open()

    pollInterval = setInterval(checkStatus, POLL_INTERVAL_MS)
}
